"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationInfoButton = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const icons_1 = require("../../../icons");
exports.NavigationInfoButton = (0, helpers_1.createUIElement)('NavigationInfoButton', (_a, ref) => {
    var { className, icon, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "icon", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    return (react_1.default.createElement(Icon_1.Icon, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, src: icon || react_1.default.createElement(icons_1.InvertInfoIconSvg, null), size: Icon_1.ICON_SIZES.xl, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-NavigationInfoButton', className) })));
});
//# sourceMappingURL=NavigationInfoButton.js.map